import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Container from '../Container';

import BackgroundWave from '../../assets/images/intro/background.png';

const Intro = (props) => {
  const { heading, headingCenter, description, image, buttonOneText, buttonOneUrl, buttonTwoText, customStyles} = props;
  return (
    <div className={`intro-sub-pages-wrapper ${customStyles || '' }`}>
      <div className="background-image-wrapper">
        <img src={BackgroundWave} alt="background-image" className="background-image"/>
      </div>
      {headingCenter && <h1 className="heading-center-text">{headingCenter}</h1>}
      <Container>
        <Grid container>
          <Grid item xs={12} sm={6}>
            <div className="left-wrapper">
              {heading && <h1 className="main-text">{heading}</h1>}
              {description && <h2 className="description small-font">{description}</h2>}
              {(buttonOneText || buttonTwoText) && <div className="button-wrapper">
                {/* {buttonOneText && (<Button size="medium" className="button-base yellow-button left-button">
                      {buttonOneText}
                    </Button>)} */}
                {buttonOneText && (
                  <Link
                    className="yellow-button"
                    to={buttonOneUrl || '/contact-us'}
                  >
                    {buttonOneText}
                  </Link>
                )}
                {buttonTwoText && (
                  <Button
                    variant="outlined"
                    size="small"
                    color="primary"
                    className="button-base outline-button"
                  >
                    {buttonTwoText}
                  </Button>
                )}
              </div>}
            </div>
          </Grid>
          {image && (
            <Grid item xs={12} sm={6} className="right-wrapper">
              <img
                className="intro-image"
                src={image}
                alt={heading}
              />
            </Grid>
          )}
        </Grid>
      </Container>
    </div>
  );
};

Intro.propTypes = {
  heading: PropTypes.node.isRequired,
  headingCenter: PropTypes.node.isRequired,
  description: PropTypes.any,
  image: PropTypes.object,
  buttonOneText: PropTypes.string,
  buttonOneUrl: PropTypes.string,
  buttonTwoText: PropTypes.string,
  customStyles: PropTypes.any,
};

export default Intro;
